// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"_2zC79ar","h5Text":"_3H_eom8","h4Text":"_3dG5n4-","h3Text":"_2twW097","srOnly":"gYh_GbV","link":"W5QqQZ7 _2zC79ar","container":"_3wSz5e5","body":"_25fsaDO _2zC79ar"};